module.exports = __webpack_public_path__ + "28bc783bccd853f59644ab5d4b2e02ee.svg";